<template>
	<div class="history">
		<h2 class="qjc-fts-20 qjc-c-dark qjc-ftw-500">历史记录 </h2>
		
		<!-- <div class="date-cell">
			<el-date-picker
				  class="year-picker"
				  :picker-options="pickerOptions" 
			      v-model="tYear"
				  value-format="yyyy"
			      type="year"
			      placeholder="选择年份">
			</el-date-picker>
			<el-select v-model="tMonth" class="month-select" placeholder="请选择月份">
			    <el-option
			      v-for="item in tMonthList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			</el-select>
			<el-button class="mainland-btn" @click="handleAction">确定</el-button>
		</div> -->
		
		
		<el-table
			:data="combo"
			header-row-class-name="qjc-fts-14 qjc-ftw-500"
			header-cell-class-name="combo-header"
			cell-class-name="qjc-fts-14"
			class="combo"
		>
			<el-table-column
				prop="name"
				label=""
				align="center"
				class-name="title qjc-ftw-500 qjc-c-dark"
			>
			</el-table-column>
			
			<el-table-column
				prop="used"
				align="center"
				class-name="used"
			>
				<div slot="header">
					累计使用次数
				</div>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.$index == 1 && scope.row.used<500 }">{{ scope.row.used }}</span>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="times"
				align="center"
				class-name="residue"
			>
				<div class="residue" slot="header">
					剩余次数
				</div>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.$index == 1 && scope.row.times<500 }">{{ scope.row.times }}</span>
				</template>
			</el-table-column>
			
		</el-table>
		
		<el-table
			:data="list"
			class="list qjc-fts-14"
			header-cell-class-name="list-header qjc-ftw-500 qjc-c-dark"
		>
			<el-table-column
				prop="version"
				label="操作"
				class-name="operate"
			>
				<template slot-scope="scope">
					<span :class="{ 'c-danger': scope.row.version >1 }">{{ scope.row.version > 1?'修改':'开通' }}</span>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="mobile"
				label="手机号"
				class-name="phone"
			>
				<template slot-scope="scope">
					{{ scope.row.mobile?scope.row.mobile:'--' }}
				</template>
			</el-table-column>
			
			<el-table-column
				prop="sex"
				label="是否完成"
				class-name="sex"
			>
				<template slot-scope="scope">
					<span>{{ scope.row.version == 0?'未完成':'已完成' }}</span>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="examdate"
				label="体检日期"
				class-name="examDate"
			></el-table-column>
			
			<el-table-column
				prop="package"
				align="center"
				class-name="basic qjc-c-dark"
			>
				<div slot="header">
					馨康母婴套餐
				</div>
				<template slot-scope="scope">
					<i class="iconduihao iconfont"></i>
				</template>
			</el-table-column>
			
			<el-table-column
				prop="operator"
				label="操作人"
				class-name="operator"
			>
			</el-table-column>
			
		</el-table>
		
		<el-pagination
			class="pagination qjc-texta-c"
			layout="prev, pager, next"
			hide-on-single-page
			:current-page.sync="pageData.page"
			:page-count="pageData.pagecount"
			:page-size="pageData.pagesize"
			:total="pageData.count"
			@current-change="pageChange"
		></el-pagination>
		
	</div>
</template>

<script>
	import "@/assets/iconfont/iconfont.css";
	import { getsbpList, getPackage } from "@/utils/axios.js";
	
	export default{
		name: 'history',
		data() {
			return {
				combo: [],
				
				list: [],//历史记录列表
				pickerOptions: {}, //年份选择范围
				monthList: [
					{
					  value: '全年',
					  label: '全年'
					},{
					  value: '1',
					  label: '1月'
					},{
					  value: '2',
					  label: '2月'
					},{
					  value: '3',
					  label: '3月'
					},{
					  value: '4',
					  label: '4月'
					},{
					  value: '5',
					  label: '5月'
					},{
					  value: '6',
					  label: '6月'
					},{
					  value: '7',
					  label: '7月'
					},{
					  value: '8',
					  label: '8月'
					},{
					  value: '9',
					  label: '9月'
					},{
					  value: '10',
					  label: '10月'
					},{
					  value: '11',
					  label: '11月'
					},{
					  value: '12',
					  label: '12月'
					},
				],
				tMonthList: [], 
				tYear: '', 
				tMonth: '',
				pageData: {
					count: 0,// 总条数
					page: 1,// 当前页
					pagecount: 0,// 总页数
					pagesize: 12// 每页条数
				}
			}
		},
		mounted() {
			getPackage({from: 'my'}).then(res => {
				if(res.code == 200){
					let data = JSON.parse(window.atob(res.data))
					this.combo.push(data.package.base);
				}else{
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			});
			
			this.tYear = new Date();
			let nowMonth = new Date().getMonth() + 1; //当前月份
			this.tMonth = nowMonth + ''; //默认选中当前月份 
			this.pickerOptions = {
				disabledDate: 
					(time) => {
					   return (
						   time > new Date()
					   )
					}
			}; // 年份选择范围 不能大于当前年份
			
			this.getHistoryList();
		},
		watch: {
			tYear(newVal, oldVal) {
				let nowYear = new Date().getFullYear();  //当前年份
				let nowMonth = new Date().getMonth() + 1; //当前月份
				let oldYear = typeof oldVal == 'string' ? oldVal : (oldVal instanceof Object ? oldVal.getFullYear() : '') 
				let newYear = typeof newVal == 'string' ? newVal : (newVal instanceof Object ? newVal.getFullYear() : '') // 是否为初始时间 或 清空
				let list = this.monthList
				// 选中当前年份时，月份列表截止当前月份
				if(nowYear == newYear){
					this.tMonthList = list.slice(0, nowMonth + 1)
					this.tMonth = nowMonth + ''
					return
				}else {
					this.tMonthList = list
				}
			},
		},
		methods: {
			// 获取历史记录数据 
			getHistoryList(page) {
				getsbpList({
					page: page || this.pageData.page,
					pagesize: this.pageData.pagesize
				}).then(res => {
					if(res.code == 200){
						// 历史记录列表数据
						this.list = res.data.data;
						
						// 分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pageData = pager;
					}else{
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
			
			// 历史记录页面切换
			pageChange(page) {
				this.getHistoryList(page);
			},
			
			// 套餐状态(有、没有、添加、删除)  参数：1、对应数据   2、对应套餐标识
			comboStatus(scope, packageName) {
				return scope.row.old_package?(scope.row.old_package.indexOf(packageName) != -1?(scope.row.package.indexOf(packageName) != -1?'iconduihao':'delete-icon iconduihao'):(scope.row.package.indexOf(packageName) != -1?'iconduihaobeifen31':'')):(scope.row.package.indexOf(packageName) != -1?'iconduihao':'');
			},
			handleAction() {
				let data = {
					year: typeof this.tYear == 'string' ? this.tYear : (this.tYear instanceof Object ? this.tYear.getFullYear() : ''),
					month: this.tMonth 
				}
			},
		}
	}
</script>

<style scoped>
	.combo >>> th,
	.combo >>> td{
		background-color: #F1F5FC;
	}
	.combo >>> th{
		height: 0.6rem;
	}
	.combo >>> td{
		height: 0.55rem;
	}
	
	.combo >>> .el-table__body tr{
		pointer-events: none;
	}
	.combo >>> td,
	.combo >>> th.is-leaf{
		border: 0.01rem solid #fff;
	}
	.combo >>> .cell{
		line-height: 0.14rem;
	}
	
	.list >>> .el-table__body, 
	.list >>> .el-table__footer, 
	.list >>> .el-table__header{
		table-layout: auto;
	}
	.list >>> .operate .cell{
		width: 0.84rem;
		padding-left: 0.16rem;
	}
	.list >>> .list-header{
		background-color: #FAFBFC;
	}
	.list >>> .list-header .cell{
		line-height: 0.16rem;
	}
	.pagination >>> button{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
	}
	.pagination >>> button .el-icon{
		font-size: 0.14rem;
	}
	.pagination >>> li{
		width: 0.32rem;
		height: 0.32rem;
		line-height: 0.32rem;
		font-size: 0.14rem;
		font-weight: 400;
		color: #40444D;
		border: 0.01rem solid transparent;
		border-radius: 0.08rem;
		margin: 0 0.06rem;
		padding: 0;
		overflow: visible;
	}
	.pagination >>> li:hover,
	.pagination >>> li.active{
		color: #6681FA;
		font-weight: 600;
		border-color: #6681FA;
		border-left: 0.01rem solid #6681FA;
	}
</style>
<style lang="scss" scoped>
	.history{
		.el-table{
			.c-danger{
				color: #FF4C52;
			}
		}
		.combo{
			color: #777F8F;
			border-radius: 0.24rem 0 0.24rem 0;
			margin-top: 0.12rem;
		}
		.list{
			color: #777F8F;
			margin-top: 0.4rem;
			
			.iconfont{
				font-size: 0.12rem;
				
				&.delete-icon{
					position: relative;
					color: #777F8F;
					
					&::after{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 100%;
						height: 0.02rem;
						content: '';
						background-color: #FF4C52;
						border-radius: 0.01rem;
						transform: translate(-50%,-50%);
					}
				}
			}
		}
		.pagination{
			margin-top: 0.24rem;
		}
		
		.date-cell {
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
		
		.year-picker {
			width: 1.2rem;
			margin-right: 0.1rem;
		}
		
		.month-select {
			width: 1rem;
		}
		
		.mainland-btn {
			width: 0.8rem;
			height: 40px;
			font-size: 0.14rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			background: #6681FA;
			border: none;
			border-radius: 0.04rem;
			margin-left: 0.1rem;
		}
	}
</style>